import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _typeof from "@babel/runtime/helpers/typeof";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useMemo } from 'react';
import { useIntl } from 'react-intl-next';
import { EVENT_TYPE } from '@atlaskit/editor-common/analytics';
import { DiscardScreen } from '@atlassian/generative-ai-modal/screens/Discard';
import { getAnalyticsAttributes } from '../../analytics/analytics-flow/analyticsFlow';
import { useAnalyticsFlowEventsQueue } from '../../analytics/analytics-flow/analyticsFlowUtils';
import { useFireAIAnalyticsEvent } from '../../analytics/utils';
import { messages as experienceMessages } from '../messages';
import { useAIExperienceCommonDataContext } from '../useAIExperienceCommonData';
export var getDiscardMessage = function getDiscardMessage(_ref) {
  var formatMessage = _ref.formatMessage,
    experienceState = _ref.experienceState;
  var discardPrompt = formatMessage(experienceMessages.discardMessagePrompt);
  var discardResponse = formatMessage(experienceMessages.discardMessageResponse);
  if (_typeof(experienceState) === 'object' && 'user input state' in experienceState) {
    return discardPrompt;
  }
  if (experienceState === 'review state' || _typeof(experienceState) === 'object' && 'loading state' in experienceState) {
    return discardResponse;
  }
  return discardResponse;
};
export function DiscardScreenWithLogic(_ref2) {
  var state = _ref2.state,
    editCount = _ref2.editCount,
    retryPromptCount = _ref2.retryPromptCount,
    history = _ref2.history,
    onceDiscard = _ref2.onceDiscard,
    channelId = _ref2.channelId;
  var aiExperienceCommonData = useAIExperienceCommonDataContext();
  var endExperience = aiExperienceCommonData.endExperience,
    sendToAIExperienceMachine = aiExperienceCommonData.sendToAIExperienceMachine,
    configItem = aiExperienceCommonData.configItem;
  var inputOutputDiffRatio = useMemo(function () {
    var lastHistoryEvent = history.entries[history.positionFromEnd];
    return history.entries.length === 0 ? '' : lastHistoryEvent.inputOutputDiffRatio;
  }, [history]);
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var fireAIAnalyticsEvent = useFireAIAnalyticsEvent();
  var analyticsFlow = useAnalyticsFlowEventsQueue({
    stepName: 'discard',
    attributes: {
      editCount: editCount,
      retryPromptCount: retryPromptCount,
      inputOutputDiffRatio: inputOutputDiffRatio
    }
  });
  return /*#__PURE__*/React.createElement(DiscardScreen, {
    text: getDiscardMessage({
      formatMessage: formatMessage,
      experienceState: state
    }),
    onCancel: function onCancel() {
      sendToAIExperienceMachine({
        type: 'disable discard'
      });
    },
    onDiscard: function onDiscard() {
      /**
       * Introduced in EDF-1443 to track discard event confirmations
       * separately to normal discard events which get tracked
       * earlier in this file
       */
      fireAIAnalyticsEvent({
        payload: {
          action: 'dismissed',
          actionSubject: 'aiInteraction',
          actionSubjectId: 'editorPluginAI',
          eventType: EVENT_TYPE.TRACK,
          attributes: _objectSpread({}, getAnalyticsAttributes(channelId, analyticsFlow.getLastAiInteractionId(), configItem.key))
        }
      });
      if (onceDiscard) {
        sendToAIExperienceMachine({
          type: 'disable discard'
        });
        onceDiscard();
      } else {
        endExperience();
      }
    }
  });
}